































































import Vue, { PropType } from 'vue';
import { IBlueprint, AIJobType } from '@/store/types';
import { AI_JOB_TYPES } from '@/store/shared';
import * as actions from '@/store/action-types';
import * as mutations from '@/store/mutation-types';
import { min } from 'd3-array';
// import { MessageBox } from 'element-ui'

const MIN_PROMPT_LENGTH = 100;

export default Vue.extend({
  name: 'AIBuildModal',
  data() {
    return {
      minPromptLength: MIN_PROMPT_LENGTH,
      loading: false as boolean,
      prompt: '' as string,
      AI_JOB_TYPES,
      placeholder:
        'Please create a cancel flow for Wayne Enterprises, a prosumer app with an audience based in North America. The flow should include offers for discounts, changing plan types, pauses and personalized support with the founder.',
      TEST_PROMPT:
        'My business is Netflix, an online streaming service. Some customers complain we are too expensive. Others often need to pause during exam season. I want to reduce churn and increase customer satisfaction.',
    };
  },
  props: {
    show: {
      type: Boolean,
    },
    jobType: {
      type: String as PropType<AIJobType>,
      default: AI_JOB_TYPES.GEN_BLUEPRINT,
    },
  },
  methods: {
    closing() {
      this.$emit('close');
    },
    async generateFlow() {
      this.$emit('submit', this.prompt);
    },
  },
  computed: {
    blueprint(): IBlueprint {
      return this.$store.getters.currentBlueprint;
    },
    promptLength(): number {
      return (this.prompt || '').length;
    },
    promptProgress(): number {
      if (this.promptLength > MIN_PROMPT_LENGTH) return 100;
      return Math.floor((this.promptLength / MIN_PROMPT_LENGTH) * 100);
    },
    enableButton(): boolean {
      return this.prompt.length >= MIN_PROMPT_LENGTH;
    },
    composingPrompt(): boolean {
      return this.prompt.length < MIN_PROMPT_LENGTH;
    },
    title(): string {
      return 'Cancel flows, done for you.';
    },
    subtitle(): string {
      return 'Tell us a little bit about your customers and if you have any specific goals or constraints. Our AI will handle the rest.';
    },
  },
});
